import React from 'react';
import { faTag } from '@fortawesome/pro-solid-svg-icons/faTag';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import TooltipMessage from '../../../components/shipment-status-icon/tooltip-message/index';
import { getCurrencyIcon } from '../../../constants/currency-codes';

import style from '../shipment-status.module.less';
import messages from './messages';

const buildPropsForPrintedLabel = (printedStatus, createdDateTime, markLabelPrinted, baseProps) => {
  const printedDateTime = get(printedStatus, 'modifiedDateTime');
  const tooltipContent = [
    <TooltipMessage key={createdDateTime} date={createdDateTime} singleMessage={messages.labelPurchased} />,
    <TooltipMessage key={printedDateTime} date={printedDateTime} singleMessage={messages.labelPrinted} />,
  ];
  return {
    ...baseProps,
    status: 'shipped',
    icon: faTag,
    onIconClick: markLabelPrinted,
    clickable: true,
    message: <FormattedMessage {...messages.printed} />,
    tooltipContent,
    iconStyle: style['label-printed-icon'],
  };
};

const buildPropsForPurchasedLabel = (createdDateTime, baseProps) => {
  const tooltipContent = <TooltipMessage date={createdDateTime} singleMessage={messages.labelPurchased} />;

  return {
    ...baseProps,
    status: 'shipped',
    message: <FormattedMessage {...messages.purchased} />,
    tooltipContent,
    iconStyle: style['label-purchased-icon'],
  };
};

export default {
  id: 'label',
  generateProps: ({ labelPrintedStatus, labelCreatedDateTime, markLabelPrinted, labelCurrencyCode }) => {
    const isPrinted = get(labelPrintedStatus, 'isPrinted', false);
    const baseProps = {
      title: <FormattedMessage {...messages.label} />,
      icon: getCurrencyIcon(labelCurrencyCode),
      status: '',
      key: 'label',
    };

    if (!labelCreatedDateTime) {
      return baseProps;
    }

    return isPrinted
      ? buildPropsForPrintedLabel(labelPrintedStatus, labelCreatedDateTime, markLabelPrinted, baseProps)
      : buildPropsForPurchasedLabel(labelCreatedDateTime, baseProps);
  },
};
